module.exports = __webpack_public_path__ + "img/pick5.a1c175bf.png";